import React from "react";

import { IconPlaySolid, Modal, ModalInnerVariant } from "@jasperlabs/jux-next";
import ReactPlayer, { type Config } from "react-player";
import Image from "next/image";
import RenderIfCondition from "../RenderIfCondition";

type Props = {
	videoUrl: string;
	heroImageUrl?: string | null;
	onVideoOpen?: (props: any) => void;
	config?: Config;
};

const defaultVimeoConfig = {
	texttrack: "en",
	quality: "auto",
	loop: false,
	autoplay: true,
	muted: false,
	controls: true,
	playsinline: false,
	background: false,
	startTime: "0m",
};

const OfferHeroVideo = ({
	videoUrl,
	heroImageUrl,
	onVideoOpen,
	config = {
		vimeo: {
			playerOptions: defaultVimeoConfig,
		},
		youtube: {
			playerVars: {
				autoplay: 1,
				controls: true,
			},
		},
	},
	...rest
}: Props) => {
	if (videoUrl && heroImageUrl) {
		return (
			<Modal
				ariaLabel="Fund overview video modal"
				innerVariant={ModalInnerVariant.Fullscreen}
				disclosure={
					<div aria-hidden onClick={onVideoOpen}>
						<button
							type="button"
							data-testid="offer-hero-video-disclosure"
							className="group relative w-full"
							aria-label="play video"
						>
							<div className="relative flex h-[190px] w-full items-center justify-center overflow-hidden rounded-md bg-neutral-50 bg-cover bg-center bg-no-repeat md:h-[420px]">
								<RenderIfCondition condition={!!heroImageUrl}>
									<Image
										src={heroImageUrl!}
										alt="Offer hero image"
										width={1440}
										height={720}
										className="w-full h-full absolute object-cover top-0 left-0 z-0"
										quality={100}
									/>
								</RenderIfCondition>
								<div className="bg-button-primary group-hover:bg-button-primary-hover flex h-[66px] w-[66px] items-center justify-center rounded-full text-[30px] text-white transition-colors duration-200 z-10">
									<IconPlaySolid className="ml-1" />
								</div>
							</div>
						</button>
					</div>
				}
			>
				<div className="mx-auto w-[80%] max-w-[960px] overflow-scroll">
					<div className="relative aspect-w-16 aspect-h-9 w-full">
						<ReactPlayer
							url={videoUrl}
							width="100%"
							height="100%"
							style={{ width: "100%", margin: "auto" }}
							config={config}
						/>
					</div>
				</div>
			</Modal>
		);
	}

	if (heroImageUrl) {
		return (
			<div
				{...rest}
				className=" flex h-[190px] w-full overflow-hidden rounded-md bg-neutral-50 bg-cover bg-center bg-no-repeat sm:h-[230px] md:h-[420px] relative"
			>
				<RenderIfCondition condition={!!heroImageUrl}>
					<Image
						src={heroImageUrl!}
						alt="Offer hero image"
						width={1440}
						height={720}
						className="w-full h-full absolute object-cover top-0 left-0 z-0"
						quality={100}
					/>
				</RenderIfCondition>
			</div>
		);
	}

	return null;
};

export default OfferHeroVideo;
